import { api } from "./api";

export const listNotifications = ({ limit = 30, skip = 0, unread_only = false } = {}) =>
  api
    .get("/notifications", { params: { limit, skip, unread_only } })
    .then((r) => r.data);

export const getUnreadCount = () =>
  api.get("/notifications/unread-count").then((r) => r.data.unread_count);

export const markRead = (id) =>
  api.post(`/notifications/${id}/read`).then((r) => r.data);

export const markAllRead = () =>
  api.post("/notifications/read-all").then((r) => r.data);

export const deleteNotification = (id) =>
  api.delete(`/notifications/${id}`).then((r) => r.data);
